import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormLayout, CheckboxWithLabel, Panel} from 'components';
import CoverageFormFactory from './CoverageFormFactory';
import StandardCoverageForm from './StandardCoverageForm';
import EvidenceMaximumForm from './EvidenceMaximumForm';
import ReductionsForm from './ReductionsForm';
import TaxableOnPayoutForm from './TaxableOnPayoutForm';

const CoverageRatesForm = observer(({uiState, step}) => {
  const {currentCoverage} = uiState;

  return (
    <div>
      <Panel.Header 
        title={t(`models.coverage_types.${step}`)} 
        description={t("taxable_benefits.COVERAGE_FORM_DESCRIPTION")} 
      />
      <FormLayout>
        <CheckboxWithLabel value={currentCoverage.excludeFromTaxableBenefits}
          checked={currentCoverage.excludeFromTaxableBenefits}
          onChange={e => currentCoverage.merge({excludeFromTaxableBenefits: e.checked})}
          label='taxable_benefits.help_text.exclude_from_taxable_benefits'/>
      </FormLayout>
      {!currentCoverage.excludeFromTaxableBenefits && <div>
        <StandardCoverageForm uiState={uiState} />
        <CoverageFormFactory uiState={uiState} />
        <EvidenceMaximumForm uiState={uiState} />
        <ReductionsForm uiState={uiState} />
        <TaxableOnPayoutForm uiState={uiState} />
      </div>}
    </div>
  );
});

export default CoverageRatesForm;
